import { render, staticRenderFns } from "./InformacionSerieDocumental.vue?vue&type=template&id=c0d66348&"
import script from "./InformacionSerieDocumental.vue?vue&type=script&lang=js&"
export * from "./InformacionSerieDocumental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports